// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import 'ztree-for-vue/public/libs/zTree_v3-master/js/jquery.ztree.all.min.js'
import 'ztree-for-vue/public/libs/zTree_v3-master/css/zTreeStyle/zTreeStyle.css' // must copy to static\static\img\zTreeStandard.524f504.png, or after build can not show imgs
import VueZtree from "ztree-for-vue";//https://github.com/arixse/vue-ztree
import Select2 from '@/components/common/selector/select2/Select2.vue'  //必须在AdminLte.min.css前面，不然AdminLte的select2样式扩展会无效
import 'font-awesome/css/font-awesome.css'
import 'ionicons/dist/css/ionicons.css'
import 'bootstrap/dist/css/bootstrap.css'
import 'admin-lte/dist/css/skins/_all-skins.css'
import 'admin-lte/dist/css/AdminLTE.min.css'
import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css'
import 'overlayscrollbars/css/OverlayScrollbars.min.css'
import 'bootstrap/dist/js/bootstrap.min.js'
import 'admin-lte/dist/js/adminlte.min.js'
import 'overlayscrollbars/js/jquery.overlayScrollbars.min.js'
import datePicker from 'vue-bootstrap-datetimepicker'//https://github.com/ankurk91/vue-bootstrap-datetimepicker
import BootstrapModal from 'vue2-bootstrap-modal' //https://github.com/joturako/vue2-bootstrap-modal
//
import App from './App'
import router from '@/router'
import axios from 'axios'
import interceptorAxios from '@/components/interceptor/axios'
import perm from '@/components/perm'
import enums from '@/components/enums' 
import dateUtils from '@/components/utils/DateUtils.js'
import menuUtils from '@/components/utils/MenuUtils.js'
import Paging from '@/components/common/paging'
import ConfirmModal from '@/components/common/modal/confirm'
import SelectorDate from '@/components/common/selector/date'
import SelectorOrderChannel from '@/components/common/selector/data/selectorOrderChannel.vue'
import SelectorAccountTree from '@/components/common/selector/data/selectorAccountTree.vue'
import SelectorEnums from '@/components/common/selector/enums/selectorEnums.vue'
import SelectorExcel from '@/components/common/selector/file/selectorExcel.vue'
import SelectorFiles from '@/components/common/selector/file/selectorFiles.vue'
import SelectorFile from '@/components/common/selector/file/selectorFile.vue'
import 'animate.css'
//https://www.jianshu.com/p/8f18ecacc4b5 vscode路径解析

$(function() {
  //悬浮滚动条不占宽度，避免loading和modal出现时的位移问题，https://github.com/KingSora/OverlayScrollbars
  $('body').overlayScrollbars({ });
});

//生成环境不提示信息
Vue.config.productionTip = false

//使用axios作http请求实现,read超时5分钟
Vue.prototype.$http = axios.create({timeout: 5*60*1000});

//为http请求添加accessToken
Vue.prototype.$http.interceptors.request.use(interceptorAxios.requestUseConfig, interceptorAxios.requestUseError);

//全局http返回错误处理
Vue.prototype.$http.interceptors.response.use(interceptorAxios.responseUseRes, interceptorAxios.responseUseError);

//路由跳转时hightlight对应的菜单
router.beforeEach(menuUtils.routerBeforeEach);

//过滤元素权限, eg v-perm="'/msu/customer/resneeded/add'"
perm.$http = Vue.prototype.$http;
Vue.directive('perm', perm.vueDirective);

//enums
enums.$http = Vue.prototype.$http;
Vue.filter('enums', enums.filterFormat);

//日期格式化
Vue.filter('dataFormat', dateUtils.format);

//全局Component注册
Vue.component('VueZtree', VueZtree);
Vue.component("DatePicker", datePicker);
Vue.component('BootstrapModal', BootstrapModal);
Vue.component('Select2', Select2);
Vue.component('SelectorDate', SelectorDate);
Vue.component('SelectorOrderChannel', SelectorOrderChannel);
Vue.component('SelectorAccountTree', SelectorAccountTree);
Vue.component('SelectorEnums', SelectorEnums);
Vue.component('SelectorExcel', SelectorExcel);
Vue.component('SelectorFiles', SelectorFiles);
Vue.component('SelectorFile', SelectorFile);
Vue.component('Paging', Paging);
Vue.component('ConfirmModal', ConfirmModal);//更推荐使用BootstrapModal，避免业务代码与jquery耦合

window.vue = new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js